// src/index.jsx — one entry for the whole site. App URLs (/studio,
// /prompter, /join, …) load the teleprompter; every other URL is the
// marketing site. Each side is its own lazy chunk, so the landing pages
// never download the app and the app never downloads the landing copy.
//
// In production the landing pages don't even reach this file: the build
// writes them out as static HTML (scripts/prerender.mjs). This router is
// what makes them work under `npm start`.
import React, { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { isAppPath } from './routes.mjs'

const App = lazy(() => import('./app/App'))
const Landing = lazy(() => import('./landing/Landing'))

const root = createRoot(document.getElementById('root'))

if (isAppPath(window.location.pathname, window.location.search)) {
  root.render(
    <React.StrictMode>
      <Suspense fallback={null}><App /></Suspense>
    </React.StrictMode>,
  )
} else {
  root.render(<Suspense fallback={null}><Landing /></Suspense>)
}
